import { useEffect, useState, useCallback } from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { DatePicker, Select, Input, message, Spin } from "antd";
import Interweave from "interweave";
import moment from "moment";
import { useRouter } from "next/router";
import Autocomplete from "react-google-autocomplete";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import PhoneInput from "react-phone-input-2";
import validator from "validator";

import { emailRegx, phoneRegx } from "../../helper/RegularExp/RegularExp";
import {
  ButtonComponent,
  InputComponent,
} from "../../helper/ReusableComponents";
import { getGooglePlaceObjectValues } from "../../helper/service";
import { _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance, logout } from "../../utilities";
import FooterNavComponent from "../FooterComponent/FooterNavComponent/FooterNavComponent";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import { NextHead } from "../NextHead/NextHead";

const { Option } = Select;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

//GetInTouch renamed to ContactUsComponent
export default function ContactUsComponent(props) {
  const router = useRouter();

  const [events, setEvents] = useState([]);
  const [showModalForWeb, setShowModalForWeb] = useState(false);
  const [contactUsCms, setContactUsCms] = useState(props?.cmsData);
  const [submitting, setSubmitting] = useState(false);
  const [websiteField, setWebsiteField] = useState("");
  const [formLoadTime] = useState(Date.now());
  const [formDataError, setFormDataError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
    venue: "",
    eventType: "",
    date: "",
    phone: "",
    contactReason: "",
  });
  const newFormData = {
    firstName: "",
    lastName: "",
    reference: 0,
    email: "",
    countryCode: "",
    phone: "",
    message: "",
    date: "",
    venue: "",
    eventType: "",
    contactReason: 1, // 0 - Other, 1 -Pricing and Availability, 2 - Performer looking to join the team 3 - I'm an Event Planner
    latitude: "",
    longitude: "",
    eventTypeName: "",
  };
  const [formData, setFormData] = useState(newFormData);
  const { firstName, lastName, email, reference } = formData;
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    fetchEvents();
    fetch_contact_us_cms_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => setShowModalForWeb(true),2000)
  }, [])

  const fetch_contact_us_cms_data = () => {
    const params = { slug: "contact-us" };
    if (props.previewKey) {
      params.previewKey = props.previewKey;
    }

    AxiosInstance(4008, "application/json")
      .post("/pages", params)
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          const responseData = response.data;
          const contactUsClone = { ...contactUsCms };
          responseData &&
            responseData.data.forEach((item) => {
              if (item.key === "contact_us") {
                contactUsClone.title = item.value;
                contactUsClone.description = item.description;
              }
              if (item.key === "phone") {
                contactUsClone.phone = item.value;
              }
              if (item.key === "image") {
                contactUsClone.img = item.value;
                contactUsClone.img_text = item.description;
              }
              if (item.key === "email") {
                contactUsClone.email = item.value;
              }
            });
          setContactUsCms(contactUsClone);
        }
      })
      .catch((err) => {
        var error = err && err.response;
        if (error && (error.status === "403" || error.status === 403)) {
          logout();
        } else if (error && (error.status === "500" || error.status === 500)) {
          console.log("Error", error.msg);
        }
      });
  };

  const fetchEvents = () => {
    AxiosInstance(4011, "application/json")
      .get("/eventTypes")
      .then((resp) => {
        const response = resp && resp.data;
        if (response.status === 200 || response.status === "200") {
          setEvents(response.data);
        }
      })
      .catch((err) => {
        var error = err && err.response;
        if (error && (error.status === "403" || error.status === 403)) {
          logout();
        } else if (error && (error.status === "500" || error.status === 500)) {
          console.log("Error", error.msg);
        }
      });
  };

  const formChangeHandler = (e) => {
    let { name, value } = e.target;
    value = value.replace(/^\s+/g, "");
    value =
      value.length === 1
        ? value.replace(" ", "")
        : value[value.length - 1] === " " && value[value.length - 2] === " "
        ? value.substring(0, value.length - 1)
        : value;
    if (value.length === 1)
      setFormDataError({
        ...formDataError,
        [name]: `Please provide more than 1 character`,
      });
    else setFormDataError({ ...formDataError, [name]: "" });
    if (name === "firstName" || name === "lastName") {
      const nameRegex = /^[A-Za-z\u00C0-\u024F\u1E00-\u1EFF\s'\-.]*$/;
      if (value.length > 0 && !nameRegex.test(value)) {
        setFormDataError({
          ...formDataError,
          [name]: "Letters, spaces, apostrophes and hyphens only",
        });
      }
    }
    if (name === "email") {
      value = value.trim();
      let emailRegExp = new RegExp(emailRegx);
      if (
        (!validator.isEmail(value) || !emailRegExp.test(value)) &&
        value.length > 0
      )
        setFormDataError({
          ...formDataError,
          email: "Please enter valid email",
        });
      else setFormDataError({ ...formDataError, email: "" });
    }
    if (name === "phone") {
      if (isNaN(value)) return;
    }
    if (name === "message") {
      if (value.length > 500) message.warning("Only 500 characters allowed");
      value = value.slice(0, 500);
    }
    setFormData({ ...formData, [name]: value });
  };

  const onPhoneInputChanges = (value, country, e, formattedValue) => {
    const { name } = e.target ? e.target : "";
    const formDataErrorNew = { ...formDataError };
    switch (name) {
      case "phone":
        formattedValue.trim() === ""
          ? (formDataError.phone = "")
          : !phoneRegx.test(formattedValue.trim()) &&
            formattedValue.trim() !== ""
          ? (formDataErrorNew.phone = "Please enter a valid phone number")
          : (formDataErrorNew.phone = "");
        break;
      default:
        break;
    }
    let phoneNo = formattedValue;
    let countryCode = "+" + e.target ? country.dialCode : value;
    setFormDataError(formDataErrorNew);
    setFormData({ ...formData, phone: phoneNo, countryCode });
  };

    
  const handleSubmit = useCallback(
   
    (e) => {
   //  e.preventDefault()
       if (!executeRecaptcha) {
         console.log("Execute recaptcha not yet available");
         return;
       }
       executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
         console.log(gReCaptchaToken,"response Google reCaptcha server");
         submitEnquiryForm(gReCaptchaToken);
       });
     },
     [executeRecaptcha, formData]
   );
  const submitEnquiryForm =useCallback((gReCaptchaToken) => {
    setSubmitting(true);
    const {
      firstName,
      lastName,
      email,
      phone,
      reference,
      eventType,
      message: formMessage,
      date,
      venue,
      countryCode,
      latitude,
      longitude,
      contactReason,
    } = formData;

    let data = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      phone: phone.trim(),
      email: email.trim(),
      reference,
      eventType,
      message: formMessage.trim(),
      date,
      venue: venue.trim(),
      countryCode,
      latitude,
      longitude,
      contactReason: contactReason,
      gRecaptchaToken: gReCaptchaToken,
    };

    if (JSON.stringify(formData) === JSON.stringify(newFormData)) {
      setSubmitting(false);
      setFormDataError({
        firstName: "Please provide first name",
        lastName: "Please provide last name",
        email: "Please provide email",
        message: "Please provide message",
        venue: "Please provide venue",
        eventType: "Please provide event type",
        date: "Please select date",
        phone: "Please provide phone number",
        contactReason: "Please select reason for contact",
      });
      return message.error("Please fill the form");
    }
    for (let [key, value] of Object.entries(data)) {
      if (value === "") {
        setSubmitting(false);
        setFormDataError({
          ...formDataError,
          [key]: `Please provide ${key
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .toLocaleLowerCase()}`,
        });
        return message.error(
          `Please provide ${key
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .toLocaleLowerCase()}`
        );
      }
      if (
        value &&
        value.length <= 1 &&
        key !== "reference" &&
        key !== "countryCode" &&
        key !== "contactReason"
      ) {
        setSubmitting(false);
        setFormDataError({
          ...formDataError,
          [key]: `Provide more than 1 character`,
        });
        return message.error(
          `Provide more than 1 character for ${key
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .toLocaleLowerCase()}`
        );
      }
    }
    // eslint-disable-next-line no-unused-vars
    for (let [key, value] of Object.entries(formDataError)) {
      if (value !== "") {
        setSubmitting(false);
        return message.error(value);
      }
    }
    data.website = websiteField;
    data._t = formLoadTime;
    AxiosInstance(4011, "application/json")
      .post("/getInTouch", data)
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          // To show band availability for entered form data
          const {
            date: eventDate,
            venue: eventLocation,
            latitude,
            longitude,
            eventTypeName,
          } = formData;
          router.push({
            pathname: `/contact-us/thank-you`,
            query: {
              formatDate: moment(eventDate, "YYYY/MM/DD").format("YYYY/MM/DD"),
              formatVenue: eventLocation
                .split(", ")
                .join("+")
                .split(" ")
                .join("+")
                .split(".")
                .join("")
                .split("-")
                .join("")
                .split("++")
                .join("+"),
              latitude,
              longitude,
              formatEventType: eventTypeName.toLowerCase(),
            },
          }, `/contact-us/thank-you`);
          setSubmitting(false);
          message.success(response.msg, 4);
          window.scrollTo(0, 0);
        } else if (
          response &&
          (response.status === 400 || response.status === "400")
        ) {
          message.error("Invalid form submission", 4);
        }
        setSubmitting(false);
      })
      .catch((err) => {
        var error = err && err.response;
        if (error && (error.status === "403" || error.status === 403)) {
          logout();
        } else if (error && (error.status === "500" || error.status === 500)) {
          message.error("Internal Server Error", 4);
        }
        setSubmitting(false);
      });
  },[formData]);

  function disabledDate(current) {
    // Can not select days before today
    return current && current < moment().add(45, "day");
    // return current && current < moment().startOf("day");
  }

  const onVenueChange = (place) => {
    const { lat, lng, address } = getGooglePlaceObjectValues(place);
    setFormData((fd) => ({
      ...fd,
      venue: address,
      latitude: lat,
      longitude: lng,
    }));
    setFormDataError({
      ...formDataError,
      venue: "",
    });
  };

  const onGoogleVenueChange = (e) => {
    setFormData({ ...formData, venue: e.target.value });
    setFormDataError({ ...formDataError, venue: "Please select venue" });
  };

  return (
    <>
      <NextHead {...props.seoData} />
      <HeaderComponent showModalForWeb={showModalForWeb} />
      <div className="contact-us-wrapper ">
        <div className="contact-us-bg h-100"></div>
        <div className="contact-us-container ">
          <div className="contact-us-headerText container">
            <h3 className="contact-us-titleText">{contactUsCms?.title}</h3>
            <div className="d-flex align-self-end contact-top-text">
              <p className="contact-us-desc">
                <Interweave
                  allowElements={false}
                  content={contactUsCms?.description}
                />
              </p>
              <div className="contact-us-ph d-flex align-self-center align-items-center flex-column">
                <h1 className="contact-us-phone">{"Phone"}</h1>
                <a
                  href={`tel:+1${contactUsCms?.phone}`}
                  className="contact-us-phoneNo"
                  // onClick={() => window.open(`tel:+1${contactUsCms.phone}`)}
                >
                  {contactUsCms?.phone}
                </a>
              </div>
            </div>
          </div>
          <div className="d-flex contact_wrap container">
            <div className="row">
              <div className="col-lg-6">
                <div className="contact-form-container">
                  <h3 className="contact-form-heading">Get in Touch</h3>
                  <h3 className="contact-form-subheading">Your Contact Info</h3>
                  <div className="row">
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Contact First Name <sup className="contact-sup">*</sup>
                      </label>
                      <InputComponent
                        formControl={{
                          placeholder: "First name",
                          onChange: formChangeHandler,
                          name: "firstName",
                          value: firstName,
                          type: "text",
                          id:"fname-input",
                          maxLength: 50,
                        }}
                      />
                      <span className="error">{formDataError.firstName}</span>
                    </div>
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Contact Last Name <sup className="contact-sup">*</sup>
                      </label>
                      <InputComponent
                          formControl={{
                          placeholder: "Last name",
                          onChange: formChangeHandler,
                          name: "lastName",
                          value: lastName,
                          type: "text",
                          id:"lname-input",
                          maxLength: 50,
                        }}
                      />
                      <span className="error">{formDataError.lastName}</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Contact Phone <sup className="contact-sup">*</sup>
                      </label>
                      <PhoneInput
                        inputProps={{
                          name: "phone",
                          id:"phone-input"
                        }}
                        disableCountryCode={true}
                        country={"us"}
                        onlyCountries={["us"]}
                        // value={
                        //   props.userDetail &&
                        //   props.userDetail.phone &&
                        //   props.userDetail.phone.number
                        // }
                        onChange={onPhoneInputChanges}
                      />
                      <span className="error">{formDataError.phone}</span>
                    </div>
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Email <sup className="contact-sup">*</sup>
                      </label>
                      <InputComponent
                        formControl={{
                          placeholder: "Email",
                          onChange: formChangeHandler,
                          name: "email",
                          value: email,
                          type: "text",
                          id:"email-input"
                        }}
                      />
                      <span className="error">{formDataError.email}</span>
                    </div>
                  </div>
                  <h3 className="contact-form-subheading mt-3">
                    Event Details{" "}
                  </h3>
                  <div className="row">
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Event Date <sup className="contact-sup">*</sup>
                      </label>
                      <DatePicker
                        id="event-date-input"
                        defaultPickerValue={
                          formData?.date
                            ? moment(formData?.date)
                            : moment().add(46, "day")
                        }
                        format="MM/DD/YYYY"
                        disabledDate={disabledDate}
                        placeholder="MM/DD/YYYY"
                        onChange={(e) => {
                          if (e !== "" && e) {
                            setFormDataError({ ...formDataError, date: "" });
                          } else {
                            setFormDataError({
                              ...formDataError,
                              date: "Please provide date",
                            });
                          }
                          setFormData({
                            ...formData,
                            date:
                              e && e._d
                                ? moment(e._d)
                                    .format("YYYY/MM/DD")
                                    .replaceAll("/", "-")
                                : "",
                          });
                        }}
                      />
                      <span className="error">{formDataError.date}</span>
                    </div>
                    <div className="col-md-6 contact-form-input">
                      <label>
                        Venue <sup className="contact-sup">*</sup>
                      </label>
                      {/* <InputComponent
                      formControl={{
                        placeholder: "Venue",
                        onChange: formChangeHandler,
                        name: "venue",
                        value: venue,
                        type: "text",
                      }}
                    /> */}
                      <Autocomplete
                        id="venue-input"
                        apiKey={process.env.GOOGLE_API_KEY}
                        options={{
                          types: ["establishment", "geocode"],
                        }}
                        onPlaceSelected={onVenueChange}
                        className="form-control"
                        onChange={onGoogleVenueChange}
                      />
                      <span className="error">{formDataError.venue}</span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col contact-form-input">
                      <label>
                        Event Type <sup className="contact-sup">*</sup>
                      </label>
                      <Select
                        id="event-type-input"
                        bordered={false}
                        placeholder="Select event"
                        onChange={(value, item) => {
                          setFormDataError({
                            ...formDataError,
                            eventType: "",
                          });
                          setFormData({
                            ...formData,
                            eventType: value,
                            eventTypeName: item?.children,
                          });
                        }}
                      >
                        {events &&
                          events.map((event) => (
                            <Option key={event._id} value={event._id}>
                              {event.name}
                            </Option>
                          ))}
                      </Select>
                      <span className="error">{formDataError.eventType}</span>
                    </div>
                    <div className="col contact-form-input">
                      <label>
                        How did you hear about us?{" "}
                        <sup className="contact-sup">*</sup>
                      </label>
                      <Select
                        id="hear-about-us-input"
                        bordered={false}
                        value={reference}
                        onChange={(value) =>
                          setFormData({ ...formData, reference: value })
                        }
                      >
                        <Option value={2}>{"Advertisements"}</Option>
                        <Option value={1}>{"Friends & Family"}</Option>
                        <Option value={0}>{"Social Networks"}</Option>
                        <Option value={3}>{"Other"}</Option>
                      </Select>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col contact-form-input">
                      <label>
                        Reason for Contact <sup className="contact-sup">*</sup>
                      </label>
                      <Select
                        id="contact-reason-input"
                        bordered={false}
                        placeholder="Select reason"
                        value={formData.contactReason}
                        onChange={(value) => {
                          setFormDataError({
                            ...formDataError,
                            contactReason: "",
                          });
                          setFormData({ ...formData, contactReason: value });
                        }}
                      >
                        <Option value={1}>{"Pricing and Availability"}</Option>
                        <Option value={2}>
                          {"Performer looking to join the team"}
                        </Option>
                        <Option value={3}>{"I'm an Event Planner"}</Option>
                        <Option value={0}>{"Other"}</Option>
                      </Select>
                      <span className="error">
                        {formDataError.contactReason}
                      </span>
                    </div>
                  </div>
                  <div className="contact-form-input mt-3">
                    <label>
                      Message <sup className="contact-sup">*</sup>
                    </label>
                    <TextArea
                      id="message-input"
                      value={formData.message}
                      onChange={formChangeHandler}
                      placeholder="Message"
                      name="message"
                      autoSize={{ minRows: 5, maxRows: 6 }}
                    />
                    <span className="error">{formDataError.message}</span>
                  </div>
                  <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }} aria-hidden="true">
                    <input
                      type="text"
                      name="website"
                      tabIndex={-1}
                      autoComplete="off"
                      value={websiteField}
                      onChange={(e) => setWebsiteField(e.target.value)}
                    />
                  </div>
                  <ButtonComponent
                    data={{
                      type: "button",
                      id:"contact-submit-btn",
                      className: "contact-us-submit-btn mt-3",
                      onClick: () => {
                        handleSubmit();
                      },
                    }}
                  >
                    {submitting ? (
                      <Spin indicator={antIcon} style={{ color: "white" }} />
                    ) : (
                      <span>Submit</span>
                    )}
                  </ButtonComponent>
                  {/* <button className="contact-us-submit-btn mt-3" onClick={handleSubmit}>{submitting ? <Spin indicator={antIcon} style={{ color: "white" }} /> :"Submit"}</button> */}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-img mx-auto">
                  <div className="cnt-img-sticky">
                    <img
                      src={process.env.IMAGE_LINK + contactUsCms?.img}
                      alt="contact_us_img"
                      className="contact-us-img"
                    />
                    <div className="contact-img-bg"></div>
                    <p className="cnt-us-img-text">
                      {" "}
                      <Interweave
                        allowElements={false}
                        content={contactUsCms?.img_text}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-5 pd-lr-15">
            <div className=" justify-content-center">
              <h2 className="cnt-us-FAQ">
                {"Or, find your answers here: "}{" "}
                <span
                  className="cnt-us-FAQ-btn"
                  onClick={() => router.push("/faq")}
                >
                  {" "}
                  FAQ
                </span>
              </h2>
            </div>
          </div>
          <div className="pd-lr-15">
            <button
              className="cnt-join-team-btn"
              onClick={() => window.open(`mailto:${contactUsCms?.email}`)}
            >
              Want to join our Team?
            </button>
          </div>
          <FooterNavComponent />
        </div>
      </div>
    </>
  );
}
